module.exports = __webpack_public_path__ + "assets/ErrorParrot2.cc0b26bf.svg";